module.exports = __webpack_public_path__ + "static/media/jazz-cash.386cd9cd.png";